import { useParams } from 'react-router-dom'

import { useQuery } from '@apollo/client'
import { TrainingMembershipFileDocument } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useNavigation } from 'modules/core/hooks/useNavigation'

import { FileViewer, File as FileViewerFile } from 'modules/trainings/components/Files/FileViewer'

export default function MyTrainingsCertificateFileViewer() {
  const { trainingId, membershipFileId } = useParams<{
    trainingId: string
    membershipFileId: string
  }>()
  const { navigation } = useNavigation()
  const { employee } = useCurrentSession()
  const { data, loading } = useQuery(TrainingMembershipFileDocument, {
    variables: {
      employeeId: employee.id,
      trainingId: Number(trainingId),
    },
  })

  if (loading) return null

  const certificates: FileViewerFile[] =
    data?.trainings?.trainingMembershipsConnection?.nodes?.flatMap((membership) =>
      membership.trainingMembershipFilesConnection?.nodes?.map((file) => ({
        id: file.id,
        filename: file.filename,
        contentType: file.contentType,
        url: file.url,
        fileUrl: file.url,
        type: 'membership',
      }))
    ) ?? []

  return (
    <FileViewer
      file={certificates.find((f) => f.id === Number(membershipFileId))}
      files={certificates}
      urlBackTo={navigation.myTrainings.revamp.detailsRevamp.view.certificates.fullPath({
        trainingId: trainingId || '',
      })}
      goNextFile={(nextFileInViewer: FileViewerFile): string => {
        if (nextFileInViewer && nextFileInViewer.id) {
          return navigation.myTrainings.revamp.detailsRevamp.view.certificates.view.fullPath({
            trainingId: trainingId || '',
            membershipFileId: String(nextFileInViewer.id),
          })
        }
        return '#'
      }}
      goPrevFile={(prevFileInViewer: FileViewerFile): string => {
        if (prevFileInViewer && prevFileInViewer.id) {
          return navigation.myTrainings.revamp.detailsRevamp.view.certificates.view.fullPath({
            trainingId: trainingId || '',
            membershipFileId: String(prevFileInViewer.id),
          })
        }
        return '#'
      }}
    />
  )
}
